import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionsReportFilterForm } from 'src/app/shared/interfaces';

import { DataWithPagination } from '../../interface';
import { SessionsReportApi } from '../api/sessions-report-api';
import { SessionsReport } from '../model';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class SessionsReportRepository extends Repository {
  constructor(private sessionsReportApi: SessionsReportApi) {
    super();
  }

  getSessionsReport(filter: SessionsReportFilterForm): Observable<DataWithPagination<SessionsReport[]>> {
    return this.sessionsReportApi.getSessionsReport(filter);
  }
}
